import React, { useState, useEffect } from 'react';
import { useAuth } from '../teacher/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

const AdminDashboard = () => {
   const { currentUser, logout } = useAuth();
  const [pendingTutors, setPendingTutors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
 


  const pendingCount = pendingTutors.length;
  // 1. Security Gate: Ensure only admins can access

//  Use your API environment variable configuration
const API_URL = process.env.REACT_APP_API_URL || 'https://trianf.com';

    const fetchPendingTutors = async () => {
    try {
      // Correct absolute path structure
      const response = await fetch(`${API_URL}/api/admin/pending-tutors`, {
        headers: {
          // If you decide to re-enable your JWT verifyToken middleware later:
          'Authorization': `Bearer ${localStorage.getItem('token')}` 
        }
      });
      
      if (!response.ok) throw new Error(`Server responded with ${response.status}`);
      
      const data = await response.json();
      setPendingTutors(data); // Bind to your dashboard UI state
    } catch (error) {
      console.error("Error retrieving tutors:", error);
      } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  fetchPendingTutors();
}, []);

  if (!currentUser || currentUser.role !== 'admin') {
    return (
      <div className="p-20 text-center">
        <h1 className="text-2xl pt-24 font-bold text-red-600">Access Denied</h1>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }


  const handleLogout = () => {
    if (logout) {
      logout();
      navigate('/login');
    }
  };

  const handleStartReview = async (tutorId) => {
    try {
      const response = await fetch(`${API_URL}/api/admin/review-tutor/${tutorId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ admin_email: currentUser.email })
      });
      if (response.ok) {
        fetchPendingTutors();
      }
    } catch (err) {
      console.error("Review error:", err);
    }
  };

  const handleApproval = async (tutorId, currentStatus) => {
    try {
      const response = await fetch(`${API_URL}/api/admin/approve-tutor/${tutorId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            approved: !currentStatus,
            status: 'approved' 
        })
      });

      if (response.ok) {
        setMessage('Tutor approved successfully!');
        fetchPendingTutors();
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (err) {
      setMessage('Failed to update status.');
    }
  };

  const handleReject = async (tutorId) => {
    const reason = prompt("Enter feedback for the tutor (reason for rejection):");
    if (!reason) return;

    try {
      const response = await fetch(`${API_URL}/api/admin/reject-tutor/${tutorId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          admin_feedback: reason,
          status: 'pending' // Reverts status so they can fix it
        })
      });

      if (response.ok) {
        setMessage('Tutor notified and moved back to drafts.');
        fetchPendingTutors();
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (err) {
      setMessage('Failed to reject tutor.');
    }
  };

  if (loading) {
    return <div className="pt-24 text-center text-blue-600 font-bold">Loading Pending Applications...</div>;
  }
  return (
    <div className="flex pt-24 bg-gray-50 min-h-screen">
   {/* ================= SIDEBAR COMPONENT LINKED HERE ================= */}
    <div className="w-64 bg-[#fbc901] text-white p-4 flex flex-col gap-4 shrink-0">
        <h2 className="text-xl font-bold border-b bg-blue-600 pb-2">Admin Panel</h2>
        
        <Link to="/tutoring/admin-dashboard" className="bg-blue-600 p-2 rounded font-medium">
          Dashboard Home
        </Link>

        {currentUser?.role === 'admin' && (
          <Link 
            to="/support" 
            className='inline-flex items-center justify-between bg-blue-600 text-white px-4 py-2 rounded font-bold hover:bg-blue-700 transition'
          >
            <span>Tutor Approvals</span>
            {pendingCount > 0 && (
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] text-white animate-pulse">
                {pendingCount}
              </span>
            )}
          </Link> 
        )}
        
        <Link to="/admin" className="bg-blue-600 hover:bg-blue-700 p-2 rounded text-white font-bold">
          System Settings
        </Link>
      </div>  
      <div className="flex-1 p-8 overflow-y-auto">
      <div className="mb-8 flex justify-between items-start bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Admin Portal: {currentUser.email}</h1>
          <span className="mt-2 inline-block bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-black uppercase tracking-wider">
              System Administrator
          </span>
        </div>
        <button 
          onClick={handleLogout}
          className="bg-[#fbc901] text-white px-5 py-2 rounded-lg font-bold text-sm hover:bg-red-600 transition-all shadow-sm"
        >
          Logout Securely
        </button>
      </div>

      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Tutor Quality Management</h2>
        <span className="text-sm text-gray-500 font-medium">
          {pendingTutors.length} Application(s) Waiting
        </span>
      </div>
      
      {message && (
        <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded shadow-sm">
          <p className="font-bold">{message}</p>
        </div>
      )}

      {/* 2. Applications Table */}
      <div className="bg-white shadow-xl rounded-xl overflow-hidden border border-gray-200">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="p-4 font-bold text-xs uppercase text-gray-500 tracking-wider">Tutor Details</th>
              <th className="p-4 font-bold text-xs uppercase text-gray-500 tracking-wider">Subject</th>
              <th className="p-4 font-bold text-xs uppercase text-gray-500 tracking-wider">Qualification</th>
              <th className="p-4 font-bold text-xs uppercase text-gray-500 tracking-wider">Current Status</th>
              <th className="p-4 font-bold text-xs uppercase text-gray-500 tracking-wider text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {pendingTutors.length === 0 ? (
              <tr>
                <td colSpan="5" className="p-16 text-center text-gray-400 italic">
                  No pending tutor approvals at this time.
                </td>
              </tr>
            ) : (
              pendingTutors.map((tutor) => (
                <tr key={tutor.id} className="hover:bg-blue-50/30 transition-colors">
                  <td className="p-4">
                    <div className="font-bold text-gray-900">{tutor.first_name} {tutor.last_name}</div>
                    <div className="text-sm text-blue-600">{tutor.email}</div>
                  </td>
                  <td className="p-4 text-sm text-gray-600 font-medium">{tutor.subject1}</td>
                  <td className="p-4 text-sm text-gray-600 italic">{tutor.teach_qfn || 'Not Provided'}</td>
                  <td className="p-4">
                    {tutor.approved ? (
    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-[10px] font-bold uppercase border border-green-200">
      Approved
    </span>
  ) : tutor.status === 'under_review' ? (
    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-[10px] font-bold uppercase border border-blue-200 animate-pulse">
      Under Review
    </span>
  ) : (
    <span className="px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-[10px] font-bold uppercase border border-amber-200">
      Pending
    </span>
  )}
</td>
                  <td className="p-4 text-right">
                    <div className="flex gap-2 justify-end">
                      {tutor.status !== 'under_review' && (
                        <button 
                          onClick={() => handleStartReview(tutor.id)}
                          className="text-blue-600 hover:bg-blue-50 px-3 py-1.5 rounded-lg text-sm font-bold transition"
                        >
                          Review
                        </button>
                      )}
                      <button 
                        onClick={() => handleApproval(tutor.id, tutor.approved)}
                        className="bg-green-600 text-white px-4 py-1.5 rounded-lg text-sm font-bold hover:bg-green-700 transition shadow-sm"
                      >
                        Approve
                      </button>
                      <button 
                        onClick={() => handleReject(tutor.id)}
                        className="bg-white text-red-600 border border-red-600 px-4 py-1.5 rounded-lg text-sm font-bold hover:bg-red-50 transition"
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
};

export default AdminDashboard;